import { createIcon } from '@chakra-ui/icon'

const GenericIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g>
      <defs xmlns="http://www.w3.org/2000/svg">
        <style>
          {
            '.cls-1{fill:#e1e4ea}.cls-1,.cls-2,.cls-3,.cls-4{stroke-width:0}.cls-2{fill:#757575}.cls-3{fill:#fff;isolation:isolate;opacity:.6}.cls-4{fill:#f9f9f9}'
          }
        </style>
      </defs>
      <g
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        focusable="false"
      >
        <g>
          <path
            d="M68.5 83.44h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4L73 20.74v58.2c0 2.5-2.1 4.5-4.5 4.5Z"
            className="cls-4"
          />
          <path
            d="M68.5 82.94c2.2 0 4-1.8 4-4v-58l-18.8-17H9.5c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5Z"
            className="cls-1"
          />
          <path
            d="M73.5 32.94h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5Z"
            className="cls-2"
          />
          <path
            d="M55.2 3.04v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0L55.2 3.04Z"
            className="cls-3"
          />
        </g>
      </g>
    </g>
  ),
})

export default GenericIcon
